import OverlayTrigger from '@rio-cloud/rio-uikit/OverlayTrigger';
import Tooltip from '@rio-cloud/rio-uikit/Tooltip';
import { FormattedMessage } from 'react-intl';
import { FunctionComponent, useId } from 'react';
import * as Sentry from '@sentry/browser';
import { MAX_VINS_INPUT } from './BulkStatusUpdateReview';
import classNames from 'classnames';
import FormLabel from '@rio-cloud/rio-uikit/FormLabel';
import { TextInput } from '../../../sharedComponents/sidebar/TextInput';
import { InputSign } from '../../../sharedComponents/InputSign';
import Button from '@rio-cloud/rio-uikit/Button';

export type VinInputProps = {
    isLoading: boolean;
    isButtonDisabled?: boolean | undefined;
    hasError: boolean;
    exceedsMaxVins: boolean;
    vins: string;
    setVins: (vinText: string) => void;
    addVins: () => void;
};
export const VinInput: FunctionComponent<VinInputProps> = (props) => {
    const inputId = useId();
    if (props.exceedsMaxVins) {
        Sentry.captureMessage(`Added VINs for bulk update over allowed MAX value of ${MAX_VINS_INPUT}.`);
    }

    return (
        <>
            <FormLabel htmlFor={inputId}>
                <FormattedMessage id="outboundOrderBook.compoundManagement.bulkStatusUpdate.table.moreVins" />
                <AddVinsTooltip />
            </FormLabel>

            <div className="display-flex flex-row align-items-end">
                <div
                    className={classNames('width-40pct', 'margin-right-10', 'form-group', {
                        'has-feedback': props.hasError,
                        'has-error': props.hasError,
                    })}
                >
                    <TextInput
                        disabled={props.isLoading}
                        id={inputId}
                        placeholder="WVWC2E75Z35692413, WVWGC31JXXW718564"
                        value={props.vins}
                        setValue={(s) => props.setVins(s ?? '')}
                        hasError={props.hasError}
                    />
                    {props.exceedsMaxVins ? (
                        <InputSign
                            messageId="outboundOrderBook.compoundManagement.bulkStatusUpdate.table.maxVins.error"
                            count={MAX_VINS_INPUT}
                            glyph="rioglyph-error-sign"
                        />
                    ) : props.hasError ? (
                        <InputSign
                            messageId="outboundOrderBook.compoundManagement.bulkStatusUpdate.table.moreVins.error"
                            glyph="rioglyph-error-sign"
                        />
                    ) : null}
                </div>
                <Button
                    bsStyle={Button.PRIMARY}
                    className={classNames('form-group', { 'btn-loading': props.isLoading })}
                    disabled={props.isButtonDisabled}
                    onClick={props.addVins}
                >
                    <FormattedMessage id="outboundOrderBook.common.button.add" />
                </Button>
            </div>
        </>
    );
};
const AddVinsTooltip = () => (
    <OverlayTrigger
        key="addVinsTooltip"
        placement="top"
        overlay={
            <Tooltip width={350} allowOnTouch>
                <FormattedMessage id="outboundOrderBook.compoundManagement.bulkStatusUpdate.table.moreVins.placeholder" />
            </Tooltip>
        }
    >
        <span
            data-testid="transport-information-tooltip"
            className="rioglyph rioglyph-info-sign text-size-18 text-color-info margin-left-5"
        />
    </OverlayTrigger>
);
